module.exports = __webpack_public_path__ + "static/neuehassunica-regular-cf4b5561fff14baba2c25ac60f8ac0e6.woff";